import styled from "styled-components";

const IconWrapper = styled.span<{ $size: number }>`
  color: inherit;
  display: inline-flex;
  height: ${(props) => `${props.$size}px`};
  position: relative;
  width: ${(props) => `${props.$size}px`};
`;

const Badge = styled.span<{ $size: number }>`
  align-items: center;
  background: #fff;
  border-radius: 999px;
  color: #000;
  display: inline-flex;
  font-size: 12px;
  font-weight: 700;
  height: ${(props) => `${Math.round(props.$size * 0.64)}px`};
  justify-content: center;
  min-width: ${(props) => `${Math.round(props.$size * 0.64)}px`};
  padding: 0 4px;
  position: absolute;
  right: -7px;
  top: -5px;
`;

type ShopBagIconProps = {
  badgeLabel?: string | null;
  size?: number;
  strokeWidth?: number;
  className?: string;
};

export const ShopBagIcon = ({
  badgeLabel = null,
  size = 32,
  strokeWidth = 1.8,
  className,
}: ShopBagIconProps) => {
  return (
    <IconWrapper $size={size} aria-hidden="true" className={className}>
      <svg
        viewBox="0 0 24 24"
        width={size}
        height={size}
        fill="none"
        stroke="currentColor"
        strokeWidth={strokeWidth}
        style={{ display: "block" }}
      >
        <path d="M3 7h18v14H3z" />
        <path d="M8.5 7V5.5a3.5 3.5 0 0 1 7 0V7" />
      </svg>
      {badgeLabel && <Badge $size={size}>{badgeLabel}</Badge>}
    </IconWrapper>
  );
};
